export const adicionarId = (urlBase, id) => id
  ? `${urlBase}?id=${id}`
  : urlBase



// WEBPACK FOOTER //
// ./src/helpers/url-helper.js